import { useMutation } from '@tanstack/react-query';
import { useFetch } from '@/hooks/useFetch';
import type { ErrorResponse, ResponseType } from '@/types/apiTypes';
import type { ClientDocumentPayload, ClientDocumentResponse } from '@/types/clientsApiTypes';

export const useUpdateClientDocumentMutation = () => {
  const { doFetch: updateClientDocument } = useFetch<
    Partial<ClientDocumentPayload>,
    ResponseType<ClientDocumentResponse>
  >();

  return useMutation<
    ResponseType<ClientDocumentResponse>,
    ErrorResponse<unknown>,
    { data: Partial<ClientDocumentPayload>; documentId: number }
  >({
    mutationFn: ({ data, documentId }: { data: Partial<ClientDocumentPayload>; documentId: number }) => {
      return updateClientDocument(`/api/documents/${documentId}`, {
        method: 'PUT',
        body: data,
      });
    },
  });
};